import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({ providedIn: 'root' })
export class CashOAuthService extends OAuthService {
  protected override createLoginUrl(
    state?: string,
    loginHint?: string,
    customRedirectUri?: string,
    noPrompt?: boolean,
    params?: never,
  ): Promise<string> {
    return super
      .createLoginUrl(state, loginHint, customRedirectUri, noPrompt, params)
      .then((url) => this.removeParameterFromUrl(url, 'code_challenge'))
      .then((url) => this.removeParameterFromUrl(url, 'code_challenge_method'));
  }

  protected removeParameterFromUrl(url, parameter) {
    return url
      .replace(new RegExp('[?&]' + parameter + '=[^&#]*(#.*)?$'), '$1')
      .replace(new RegExp('([?&])' + parameter + '=[^&]*&'), '$1');
  }
}
